import {Component, Inject} from '@angular/core';
import {DIALOG_CONFIG, DialogConfig} from 'ac-infra';
import {cloneDeep} from "lodash";

@Component({
    selector: 'tenant-commitment-dialog',
    templateUrl: './tenant-commitment-dialog.component.html',
    styleUrls: ['./tenant-commitment-dialog.component.less']
})
export class TenantCommitmentDialogComponent {

    formSettings = {valid: true, touched: true};
    tenant: any;
    commitmentObject: any = {title: 'Commitment File', files: [], commitmentFileId: -1};

    schema = require('../../../../schema/post/commitmentitemprocessor.json');

    constructor(@Inject(DIALOG_CONFIG) public dialogConfig: DialogConfig) {}

    ngOnInit() {
        this.tenant = this.dialogConfig.dialogData.tenant;
        this.tenant.tenantId = this.tenant.id;
        this.commitmentObject.commitmentFileId = this.tenant.commitmentFileId;
    }
}


